// src/utils/getUserRole.js
import { jwtDecode } from "jwt-decode";

export const isTokenValid = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 > Date.now();
  } catch (error) {
    console.warn("Invalid token format", error);
    return false;
  }
};

export const isLoggedIn = () => {
  const valid = isTokenValid();
  if (!valid) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }
  return valid;
};

export const getUserRole = () => {
  if (!isLoggedIn()) return null;
  try {
    const user = localStorage.getItem("user");
    if (!user) return null;
    const parsed = JSON.parse(user);
    return parsed.role || null;
  } catch (error) {
    console.error("Error parsing user from localStorage", error);
    return null;
  }
};
export const isAdmin = () => {
  return getUserRole() === "SUPERADMIN";
};
